import TabBarPill from './TabBarPill';
export {renderTabBarPill} from './TabBarPill';

export default TabBarPill;
